import cx from 'classnames'
import { FC } from 'react'

type Props = {
  marginLeft?: string | null
}

const RequiredLabel: FC<Props> = ({ marginLeft = null }) => {
  return (
    <span className={cx('c-requiredLabel')} style={marginLeft != null ? { marginLeft: marginLeft } : {}}>
      必須
    </span>
  )
}

export default RequiredLabel
